import { ICustomAnimationProps } from "@thekilroygroup/shared-ui";
import theme from "theme";

export const backgroundAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 1,
  delayOut: 750,
  timeout: { enter: 500, exit: 250 },
  direction: "down",
  easing: theme.transitions.easing.easeInOut,
};

export const searchLoaderAnimations: ICustomAnimationProps = {
  type: "grow",
  delay: 250,
  delayOut: 1,
  timeout: { enter: 350, exit: 250 },
  mountOnEnter: true,
  unmountOnExit: true,
  easing: theme.transitions.easing.easeInOut,
};

export const searchHeaderAnimations: ICustomAnimationProps = {
  type: "collapse",
  delay: 250,
  delayOut: 500,
  timeout: { enter: 250, exit: 100 },
  direction: "down",
  mountOnEnter: true,
  easing: theme.transitions.easing.easeIn,
};

export const desktopFiltersAnimations: ICustomAnimationProps = {
  type: "slide",
  delay: 250,
  delayOut: 1,
  timeout: { enter: 250, exit: 250 },
  direction: "right",
  easing: theme.transitions.easing.easeOut,
};

export const discountTextBoxAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 500,
  delayOut: 1,
  timeout: { enter: 250, exit: 250 },
  easing: theme.transitions.easing.easeOut,
};

export const sortContainerAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 250,
  delayOut: 1,
  timeout: { enter: 250, exit: 250 },
  easing: theme.transitions.easing.easeOut,
};

export const searchResultsAnimations: ICustomAnimationProps = {
  type: "fade",
  delay: 500,
  delayOut: 1,
  timeout: { enter: 1, exit: 250 },
  easing: theme.transitions.easing.easeIn,
};

export const navigateDelay = 750;
